<template>
  <div class="container">
    <section class="section intro">
      <div class="background">
        <img src="./../assets/images/home_banner.jpg" alt="background"/>
      </div>
      <div class="content">
        <p class="title" v-html="$translations.get('home_title')"></p>
        <p class="title" v-html="$translations.get('home_subtitle')"></p>
        <p class="text" v-html="$translations.get('home_text')"></p>
        <router-link to="/bodies" class="continue">{{$translations.get("continue")}}</router-link>
        <span class="separator"></span>
        <span class="mouse-wheel">
          <img src="../assets/images/mouse.svg" alt="mouse">
        </span>
      </div>
    </section>
    <section class="section why-wagner">
      <div class="background">
        <img src="./../assets/images/img1.jpg" alt="background"/>
      </div>
      <div class="content">
        <div class="big-title">
          <span class="left-side">WAGNER</span>
          <span class="right-side">HATFIELD</span>
        </div>
        <div class="text-section pull-left">
          <p class="header" v-html="$translations.get('home_section_1_header')"></p>
          <p class="title" v-html="$translations.get('home_section_1_title')"></p>
          <div class="text" v-html="$translations.get('home_section_1_text')"></div>
        </div>
      </div>
    </section>
    <section class="section our-knowledge">
      <div class="background">
        <img src="./../assets/images/img2.jpg" alt="background"/>
      </div>
      <div class="content">
        <div class="text-section pull-right">
          <p class="header" v-html="$translations.get('home_section_2_header')"></p>
          <p class="title" v-html="$translations.get('home_section_2_title')"></p>
          <div class="text" v-html="$translations.get('home_section_2_text')"></div>
        </div>
      </div>
    </section>
    <section class="section research-training">
      <div class="background">
        <img src="./../assets/images/img3.jpg" alt="background"/>
      </div>
      <div class="content">
        <div class="text-section pull-left">
          <div class="text">
            <div v-html="$translations.get('home_section_3_text')">

            </div>
            <router-link to="/bodies" class="read-more">{{$translations.get("read-more")}}</router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="section what-we-cover">
      <div class="background">
        <img src="./../assets/images/bottom_picture.jpg" alt="background"/>
        <div class="white-overlay"></div>
      </div>
      <div class="content">
        <div class="text-section">
          <p class="header" v-html="$translations.get('home_section_4_header')"></p>
          <p class="title" v-html="$translations.get('home_section_4_title')"></p>
          <div class="text">
            <div v-html="$translations.get('home_section_4_text_1')">
              <b>Media & Telecom</b><br>
              <ul>
                <li>
                  Regulatory affairs
                </li>
                <li>
                  European media policy
                </li>
                <li>
                  Strategic development
                </li>
                <li>
                  Business intelligence
                </li>
              </ul>
            </div>
            <div v-html="$translations.get('home_section_4_text_2')">
              <b>Public Institutions</b><br>
              <ul>
                <li>
                  Public management & organisation
                </li>
                <li>
                  Policy evaluation
                </li>
                <li>
                  Institutional communication
                </li>
                <li>
                  Democratic transition & capacity-building
                </li>
              </ul>
            </div>
            <div v-html="$translations.get('home_section_4_text_3')">
              <b>Corporate</b><br>
              <ul>
                <li>
                  Regulatory Affairs -Policy analysis
                </li>
                <li>
                  Advocacy campaign development
                </li>
                <li>
                  Strategic development
                </li>
                <li>
                  Corporate communication
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer-section :background="require('./../assets/images/home_footer.jpg')"/>
  </div>
</template>

<script>
  import FooterSection from "@/components/FooterSection";

  export default {
    name: 'Home',
    metaInfo: {
      title: "Home"
    },
    components: {FooterSection}
  }
</script>

<style lang="scss" scoped>
  @import '../static/css/style';

  .section {
    background: #fff;

    &.intro {

      .background img {
        @include absolute-stretch();

        &:nth-child(1) {
          object-position: top !important;
        }

        &:nth-child(2) {
          object-position: bottom !important;
        }
      }

      .content {
        height: 100vh;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;

        .title {
          font-size: 2.5rem;
          margin: 0.1em;
          color: #fff;
          font-family: 'OpenSans-Bold', sans-serif;
          text-align: center;
        }

        .text {
          font-size: 1rem;
          text-align: center;
          width: 43%;
          color: #fff;
          margin-top: 3em;
          margin-bottom: 3em;
          font-family: 'NeueHaasUnicaPro-Medium', sans-serif;
        }

        .continue {
          position: relative;
          text-transform: uppercase;
          font-size: 0.8rem;
          letter-spacing: 0.3em;
          color: rgba(255, 255, 255, 0.9);
          padding-bottom: 1.5em;
          text-decoration: none;
          outline: 0;
          font-family: 'NeueHaasUnicaPro-Medium', sans-serif;
          @include transition(color $default-ease 200ms);

          &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            bottom: 1.5em;
            left: -2em;
            width: 1em;
            background: url("./../assets/images/arrow.svg") center no-repeat;
            background-size: contain;
          }

          &::after {
            content: '';
            display: block;
            height: 0.1rem;
            position: absolute;
            left: -1em;
            right: -1em;
            bottom: 1em;
            background: rgba(255, 255, 255, 0.3);
            @include transition(left $default-ease 200ms, right $default-ease 200ms, background-color $default-ease 200ms);
          }

          &:hover {
            color: #25CFCF;

            &::after {
              left: -2em;
              right: -2em;
              background: #25CFCF;
            }
          }
        }

        .separator {
          width: 0.1rem;
          height: 4rem;
          display: block;
          background: rgba(255, 255, 255, 0.3);
          margin-bottom: 80px;
        }

        .mouse-wheel {
          position: absolute;
          bottom: 30px;
          left: 50%;
          width: 30px;
          margin-left: -15px;
        }
      }
    }

    &.why-wagner {

      .background img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 50% !important;
        object-position: bottom !important;
      }

      .content {

        .text-section {

          .text {
            padding-top: 8rem;
            padding-bottom: 8rem;
          }
        }

        .big-title {
          position: absolute;
          top: 1em;
          left: 0;
          right: 0;
          font-size: 8rem;
          line-height: 8rem;

          .left-side {
            position: absolute;
            left: 5vw;
            color: rgba(0, 0, 0, 0.1);
          }

          .right-side {
            position: absolute;
            right: 0;
            color: rgba(255, 255, 255, 0.3);
          }
        }
      }
    }

    &.our-knowledge {

      .background img {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 48% !important;
        object-position: bottom !important;
        z-index: 5;
      }
    }

    &.research-training {
      z-index: 5;

      .background img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: -10%;
        width: 50% !important;
        height: 110% !important;
        object-position: bottom !important;
      }

      .content {

        .text-section {

          .text {
            padding-bottom: 10vh;
          }
        }
      }
    }

    &.what-we-cover {

      .background {

        img {
          object-position: 50% 30% !important;
        }
      }

      .content {
        padding-top: 30vh;

        .text-section {

          .text {
            position: relative;
            display: flex;
            padding-top: 4rem;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            max-width: 100% !important;

            &::after {
              content: '';
              display: block;
              position: absolute;
              top: 0;
              left: -4rem;
              bottom: -4rem;
              right: -1rem;
              background: #fff;
              z-index: -1;
            }
          }
        }
      }
    }

    @include media-query(medium) {

      &.intro {

        .content {

          .text {
            width: 90%;
          }
        }
      }

      &.why-wagner {
        padding-top: 60vh;

        .background {
          height: 60vh;

          img {
            width: 100% !important;
          }
        }

        .content {

          .text-section {

            .text {
              padding-top: 0;
              padding-bottom: 0;
            }
          }

          .big-title {
            display: none;
          }
        }
      }

      &.our-knowledge {
        padding-top: 60vh;

        .background {
          height: 60vh;

          img {
            width: 100% !important;
          }
        }
      }

      &.research-training {
        padding-top: 60vh;

        .background {
          height: 60vh;

          img {
            height: 100% !important;
            width: 100% !important;
            bottom: 0 !important;
          }
        }
      }

      &.what-we-cover {

        .background {

          img {
            object-position: 50% 30% !important;
          }
        }

        .content {
          padding-top: 30vh;

          .text-section {

            .text {
              justify-content: flex-start;

              & > * {
                flex: 100%;
              }

              &::after {
                top: -6rem;
                left: -3rem;
                bottom: -3rem;
                right: -3rem;
              }
            }
          }
        }
      }
    }
  }

  .loaded {

    .intro {

      .background img {

        &:nth-child(1) {
          @include animation(zoomOut 2s ease-out 0s 1 both);
        }

        &:nth-child(2) {
          @include animation(fadeIn 2s $default-ease 0s 1 both);
        }
      }

      .title:nth-child(1) {
        @include animation(fadeIn 1s $default-ease 700ms 1 both);
      }

      .title:nth-child(2) {
        @include animation(fadeIn 1s $default-ease 900ms 1 both);
      }

      .text {
        @include animation(fadeIn 1s $default-ease 1s 1 both);
      }

      .continue {
        @include animation(fadeIn 1s $default-ease 1.1s 1 both);
      }

      .continue::after {
        @include animation(widthStretch 1s $default-ease 1.2s 1 both);
      }

      .separator {
        @include animation(fadeIn 1s $default-ease 1.2s 1 both);
      }

      .mouse-wheel {
        @include animation(fadeIn 1s $default-ease 1.2s 1 both);
      }
    }
  }
</style>
